<ng-container *ngIf="!showConfirmation; else confirmationModal">
    <div class="modal-body">
        <cm-display-html class="details-description" [content]="step.description"></cm-display-html>
        <p class="details-description font-weight-bold">Upload documents to show that you have already paid the fee:</p>
        <cm-file-upload (change)="onFilesChange($event)" [files]="files"></cm-file-upload>
        <cm-inline-error [errorMessages]="errorMessages"></cm-inline-error>
    </div>
    <div class="modal-footer footer-container">
        <button type="button" class="btn btn-default" (click)="switchScreen.emit(FeesScreens.Initial)">BACK</button>
        <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
        <button type="button" class="btn btn-primary" (click)="confirmUpload()">UPLOAD</button>
    </div>
</ng-container>

<ng-template #confirmationModal>
    <div class="modal-body"><cm-confirm-info [info]="uploadInfo"></cm-confirm-info></div>
    <div class="modal-footer footer-container">
        <button type="button" class="btn btn-default" (click)="declineConfirmation()">BACK</button>
        <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
        <button type="button" class="btn btn-primary" (click)="uploadFiles()">UPLOAD</button>
    </div>
</ng-template>
